import ParticipantInfoForm from "./participantInfoForm.container";

export default ParticipantInfoForm;
